import React, { useEffect } from 'react';

import { Button } from '@mui/material';
import { Stack } from '@mui/system';
import { Header } from 'components/home';
import { ItemForm } from 'components/shared/item_form';
import { PageTitle } from 'components/shared/page_title';
import { TopNavBar } from 'components/top_nav_bar';
import { MenuProvider } from 'contexts/menu/menu_context';
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
import useCifaStore from 'stores/cifa/cifa.store';
import { CifaStatusEnum } from 'enum/cifaStatus.enum';
import { getStatusText, validateAllPending } from './createCifa.helpers';

export interface InstitutionI {
  id: number;
  name: string;
}

const CreateCifa: React.FC = () => {
  const { cifa, getCifa, sendToApproval } = useCifaStore();
  const navigate = useNavigate();
  const location = useLocation();

  // Extrai o ano da rota, ex: /service_management/cifa-2027 => 2027
  const match = /cifa-(\d{4})/.exec(location.pathname);
  const anoReferencia = match ? Number(match[1]) : 2026;
  const isEdit = location.state?.mode === "edit";


  const handleBack = () => {
    navigate(ROUTES[`CIFA${anoReferencia}` as keyof typeof ROUTES] as string);
  };


  const handleVerify = (): boolean => validateAllPending(cifa);

  const handleSendToApproval = async () => {
    const response = await sendToApproval();
    if (response.status == 'OK') {
      alert(response.Mensagem);
      return window.location.reload();
    }
    alert(response.Mensagem);
  }

  useEffect(() => {
    if (!cifa?.uuid) {
      handleBack();
    }
    getCifa(cifa.institution_uuid, cifa.ano_referencia);
    // eslint-disable-next-line
  }, []);

  return (
    <MenuProvider>
      <TopNavBar />

      <Header
        title={`CIFA - ${isEdit ? "Alterar Município" : "Cadastrar Município"} - ${anoReferencia}`}
        showBackButton={true}
      />

      <PageTitle
        title={`${isEdit ? "Alterar Município" : "Cadastro de Município"} - CIFA ${anoReferencia}`}
        subtitle={
          isEdit
            ? "Atualize os dados do município. Após revisar todas as etapas, confirme a alteração."
            : "Responda todo o questionário corretamente. Apenas após o preenchimento de todas as etapas abaixo, você poderá confirmar o Cadastro do Município."
        }
      />

      <Stack marginX='4rem' spacing='2rem'>
        <ItemForm
          number={1}
          title='Cumprimento do Termo Escolar'
          subtitle='Informe os dados sobre o cumprimento dos requisitos do Termo de Adesão pelo Município.'
          status={getStatusText(cifa.status_aba_1)}
          pathTo={ROUTES[`COMPLIANCE_TERM_${anoReferencia}` as keyof typeof ROUTES] as string}
          isEdit
        />
        <ItemForm
          number={2}
          title='Assistência Técnica e Extensão Rural'
          subtitle='Preencha as informações sobre os atendimentos ATER realizados no Município.'
          status={getStatusText(cifa.status_aba_2)}
          pathTo={ROUTES[`TECH_ASSIST_${anoReferencia}` as keyof typeof ROUTES] as string}
          isEdit
        />
        <ItemForm
          number={3}
          title='Alimentação Escolar e Aquisição'
          subtitle='Informe os dados sobre a aquisição de Alimentação Escolar no Município.'
          status={getStatusText(cifa.status_aba_3)}
          pathTo={ROUTES[`SCHOOL_FEEDING_${anoReferencia}` as keyof typeof ROUTES] as string}
          isEdit
        />
        <ItemForm
          number={4}
          title='Recurso Financeiro Aplicado'
          subtitle='Preencha as informações sobre os valores destinados e aplicados à dinamização da agricultura familiar no Município.'
          status={getStatusText(cifa.status_aba_4)}
          pathTo={ROUTES[`FINANCIAL_RESOURCE_${anoReferencia}` as keyof typeof ROUTES] as string}
          isEdit
        />

        <Stack
          direction='row'
          spacing={2}
          justifyContent='center'
          alignItems='center'
          marginTop='2rem'
        >
          <Button variant='text' color='primary' onClick={handleBack}>
            Voltar
          </Button>
          <Button variant='contained' color='primary' disabled={!handleVerify()} onClick={handleSendToApproval}>
            Confirmar e Enviar
          </Button>
        </Stack>

        <Stack marginX='4rem' marginTop='2rem'></Stack>
      </Stack>
    </MenuProvider>
  );
};

export default CreateCifa;
